import styled from "styled-components";

export const Container = styled.div`
  padding-top: 1rem;

  form {
    display: flex;
    gap: 0.4rem;
  }

  input {
    padding: 1rem;
  }

  button {
    padding: 0.5rem 0.7rem;
    background: blue;
    border: none;
    cursor: pointer;
  }
`;